import { ActionType, AddPointAction } from '@/actions/actiontypes';
import { useMap } from '@/state/context/MapContext';
import { useDispatch } from '@/state/store';
import { ControlledMenu, MenuItem, useMenuState } from '@szhsin/react-menu';
import '@szhsin/react-menu/dist/core.css';
import copy from 'clipboard-copy';
import { MapBrowserEvent } from 'ol';
import { EventsKey } from 'ol/events';
import { unByKey } from 'ol/Observable';
import { useCallback, useEffect, useState } from 'react';
import * as uuidgen from 'uuid';

const fNumber = (number: number) => number.toFixed(0);
type ContextMenuOn = (
    type: 'contextmenu',
    listener: (event: MapBrowserEvent<PointerEvent>) => unknown
) => EventsKey;

export const ContextMenu = () => {
    const { map } = useMap();
    const dispatch = useDispatch();
    const [menuProps, toggle] = useMenuState();
    const [anchorPoint, setAnchorPoint] = useState({ x: 0, y: 0 });
    const [coordinates, setCoordinates] = useState<[number, number]>([0, 0]);
    const createMarker = useCallback(() => {
        const action: AddPointAction = {
            type: ActionType.MAP_POINT_ADDED,
            point: { id: uuidgen.v4(), geometry: coordinates },
        };
        dispatch(action);
    }, [dispatch, coordinates]);
    const showMenu = useCallback(
        (e: MapBrowserEvent<PointerEvent>) => {
            if (isPopupContextMenuTarget(e.originalEvent.target)) {
                toggle(false);
                return;
            }

            e.preventDefault();
            const { clientX: x, clientY: y } = e.originalEvent;
            setAnchorPoint({ x, y });
            const [east, north] = e.coordinate;
            setCoordinates([east, north]);
            toggle(true);
        },
        [toggle, setAnchorPoint]
    );

    useEffect(() => {
        const key: EventsKey = (map.on as unknown as ContextMenuOn).call(
            map,
            'contextmenu',
            showMenu
        );
        return () => {
            unByKey(key);
        };
    }, [map, showMenu]);

    return (
        <div id="menu-wrapper">
            <ControlledMenu
                {...menuProps}
                anchorPoint={anchorPoint}
                onClose={() => toggle(false)}
            >
                <MenuItem
                    onClick={() => copy(coordinates.map(fNumber).reverse().join(' '))}
                >
                    Kopier koordinater
                </MenuItem>
                <MenuItem onClick={createMarker}>Lag markør</MenuItem>
                <MenuItem disabled={true}>
                    Nord:{' '}
                    <span style={{ userSelect: 'all', fontWeight: 'normal' }}>
                        {fNumber(coordinates[1])}
                    </span>
                </MenuItem>
                <MenuItem disabled={true}>
                    Øst:{' '}
                    <span style={{ userSelect: 'all', fontWeight: 'normal' }}>
                        {fNumber(coordinates[0])}
                    </span>
                </MenuItem>
            </ControlledMenu>
        </div>
    );
};

const isPopupContextMenuTarget = (target: EventTarget | null) => {
    return target instanceof Element && !!target.closest('.o-popup');
};
